import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';

@Component({
    selector: 'app-add-basket',
    templateUrl: './add-basket.component.html',
    styleUrls: ['./add-basket.component.scss'],
})
export class AddBasketComponent implements OnInit {

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    constructor(
        protected _messageService: MessagesService) {
        }

    ngOnInit() {
    }

    public validate(data) {
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
